
import { Placement } from '@post-office/placements-frontend/jsm-assets-app-navbar-dashboards-section';
export default Placement;
